module.exports = __webpack_public_path__ + "img/white.10913984.png";